import { call, put, takeEvery } from 'redux-saga/effects';
import i18next from 'i18next';
import { _CALLGETAPI } from '../../api/apiHandler';
import * as actionTypes from '../../constants/ActionTypes/HardwareInclusive/HardwareInclusive';
import { _HARDWARE_API_ENDPOINTS, SUCCESS } from '../../constants/AppConstants';
import { extractCountryCodeFromDomain } from '../../utils/Internationalization/handleAppInternationalization';

function _fetchHardwareInclusiveCounter() {
    const endpoint = _HARDWARE_API_ENDPOINTS.GET_HWINC_PRINTER_STOCK
    const countryCode = extractCountryCodeFromDomain().toUpperCase();
  
    const payload = {
        params: {
            countryCode:countryCode
        }
    };
    return _CALLGETAPI(endpoint, payload)
        .then(response => response)
        .catch((error) => {
            throw error;
        });
}


function* handleInfo() {
    try {
        const result = yield call(_fetchHardwareInclusiveCounter);
        (result.actionStatus.toUpperCase() === SUCCESS)
        ? yield put({ type: actionTypes.GET_HARDWARE_INCLUSIVE_COUNTER_SUCCESS, data: result })
        : yield put({
            type: actionTypes.GET_HARDWARE_INCLUSIVE_COUNTER_FAILURE,
            message: i18next.t('ERROR_CONTENT.ERR_INFO.TECHNICAL_ERROR')
        });
    } catch (e) {
        yield put({
            type: actionTypes.GET_HARDWARE_INCLUSIVE_COUNTER_FAILURE,
            message: i18next.t('ERROR_CONTENT.ERR_INFO.TECHNICAL_ERROR')
        });
    }
}

function* HardwareInclusiveCounter_FETCH() {
    yield takeEvery(actionTypes.GET_HARDWARE_INCLUSIVE_COUNTER_INIT, handleInfo);
}

export default HardwareInclusiveCounter_FETCH;
